import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { isbot } from 'isbot';
import {
  APP_ENV, AUTHOR_IMAGE_PLACEHOLDER, BYLINE_STICKY_ON, SITE_HOST, SPOT_ID_QA, SPOT_ID_PROD
} from '../../consts';
import '../../css/react-css-transitions.scss';
import {
  getArticleModulesWithAds, getContentHubWithAds, getSponsoredArticleWithAds, getFileName, getGuideWithAds, getIsTrackable, getQuizWithAds, segmentTrackPage, decodeTags, removeTags, isValid, isText, decodeSpecialCharacters, cerosTracking, setHtlTargetingAndPageview
} from '../../utils';
import Loading from '../App/Loading';
import MetaTags from '../common/MetaTags';
import Recirculation from '../common/Recirculation';
import withArticleTracking from '../common/withArticleTracking';
import withSegmentScroll from '../common/withSegmentScroll';
import './article-styles-pw.scss';
import ArticleContentNav from './ArticleContentNav';
import ArticleHeader from './ArticleHeader';
import ArticleModules from './ArticleModules/ArticleModules';
import VideoHero from './ArticleModules/EmbedModule/VideoHero';
import EmbedModule from './ArticleModules/EmbedModule/EmbedModule';
import ImageModule from './ArticleModules/ImageModule/ImageModule';
import QuizBox from './ArticleModules/Quiz/QuizBox';
import PrintRecipe from './ArticleModules/RecipeModule/PrintRecipe';
import Recipe from './ArticleModules/RecipeModule/Recipe';
import RecipeHeader from './ArticleModules/RecipeModule/RecipeHeader';
import Byline from './Byline';
import AuthorBios from './AuthorBios/AuthorBios';
import Disclaimer from './ArticleModules/Disclaimer/Disclaimer';
import GuideArticleMobile from './GuideArticleMobile';
import ProductReviewProcess from './ProductReviewProcess';
import SocialShareButtons from './SocialShareButtons/SocialShareButtons';
import VerticalModules from '../Lander/VerticalModules';

const isTruthyMetaValue = value => ['1', 'true'].includes(String(value).toLowerCase());

export class Article extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPrintRecipe: false,
      average: null,
      numOfRatings: null,
      recirculation: [],
    };
    this.togglePrint = this.togglePrint.bind(this);
    this.getRating = this.getRating.bind(this);
    this.getRecirculation = this.getRecirculation.bind(this);
  }


  getRating(id) {
    let self = this;
    const fetchRatings = async () => {
      const completePath = `https://ratings-api.gallerymediagroup.net/get/recipe/${id}`;
      await fetch(completePath, {
        headers: {
          Accept: 'application/json',
        },
        redirect: 'follow',
      }).then(data => {
        return data.json()
      }).then(response => {
        const avg = (Math.round(response.Average * 10) / 10);
        const count = response.Count;
        self.setState({average: avg, numOfRatings: count});
      }).catch(e => {
        console.log('fetch failed:', e);
        // explicitly returns null for errors which results in 404 page loading instead of page breaking
      });
    };
    fetchRatings();
  }

  getRecirculation(category, id) {
    let self = this;
    const fetchRecirculation = async () => {
      const completePath =  `/api/recirculation/${category}/${id}`;
      await fetch(completePath, {
        headers: {
          Accept: 'application/json',
        },
        redirect: 'follow',
      }).then(data => {
        return data.json();
      }).then(response => {
        self.setState({recirculation: response.recirculation});
      }).catch(e => {
        console.log('fetch failed:', e);
        // explicitly returns null for errors which results in 404 page loading instead of page breaking
      });
    };
    fetchRecirculation();
  }

  componentDidMount() {
    if (!this.props.isLoading) {
      const { article } = this.props;
      const { category, tags, settings, modules, brandSafetyCat, brandSafetyRating, brandSafety } = article;
      const isCeros = settings.articleLayout === 'Ceros';
      const titleTag = article.seo.titleTag;
      segmentTrackPage(titleTag, this.props.standardArticleTracker);
      this.getRecirculation(category, article.id);
      const articleType = (isValid(article.sponsorship)) ? article.sponsorship.articleType : null;
      const isSponsored = articleType === 'Sponsored';
      const recipeModule = modules.filter(module => module.type === 'recipe' || module.type === 'recipe-basic');
      const isTesting = APP_ENV === "PROD" ? "no" : "yes";
      const isRecipe = (recipeModule && recipeModule.length > 0);
      const adType = settings.hideProgrammaticAds == 1 ? 'directonly' : null;
      const ua = navigator.userAgent; 
      const bot = isbot(ua) ? 'bot' : 'human';

      setHtlTargetingAndPageview({
        context: "article:mount",
        targeting: {
          ad_type: adType,
          type: articleType,
          context_tags: tags,
          is_testing: isTesting,
          is_home: "no",
          post_id: article.id,
          id: article.id,
          is_Sponsored: isSponsored,
          category: category,
          env: APP_ENV,
          brand_safety_cat: brandSafetyCat,
          brand_safety_rating: brandSafetyRating,
          brand_safety: brandSafety,
          ua: bot,
        },
      });

      if (isCeros) {
        document.body.addEventListener('ceros-analytics-event', cerosTracking);
      }
      if (isRecipe && settings.hideRecipeRatings != 1) {
        this.getRating(article.id);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.article.id !== this.props.article.id && !this.props.isLoading) {
      const { article } = this.props;
      const { category, tags, settings, brandSafetyCat, brandSafetyRating, brandSafety } = article;
      const isCeros = settings.articleLayout === 'Ceros';
      const titleTag = article.seo.titleTag;
      const articleType = (isValid(article.sponsorship)) ? article.sponsorship.articleType : null;
      const isSponsored = articleType === 'Sponsored';
      const isTesting = APP_ENV === "PROD" ? "no" : "yes";
      //const adType = (category == 'fashion' || settings.hideProgrammaticAds == 1) ? 'directonly' : null;
      const adType = settings.hideProgrammaticAds == 1 ? 'directonly' : null;
      const ua = navigator.userAgent;
      const bot = isbot(ua) ? 'bot' : 'human';
      segmentTrackPage(titleTag, this.props.standardArticleTracker);
      this.getRecirculation(category, article.id);

      if (document.getElementById('sticky-byline-wrapper')) {
        document.getElementById('sticky-byline-wrapper').classList.remove('unstick');
      }
      setHtlTargetingAndPageview({
        context: "article:update",
        targeting: {
          ad_type: adType,
          type: articleType,
          context_tags: tags,
          is_testing: isTesting,
          is_home: "no",
          post_id: article.id,
          id: article.id,
          is_Sponsored: isSponsored,
          category: category,
          env: APP_ENV,
          brand_safety_cat: brandSafetyCat,
          brand_safety_rating: brandSafetyRating,
          brand_safety: brandSafety,
          ua: bot,
        },
      });
      
      if (isCeros) {
         document.body.addEventListener('ceros-analytics-event', cerosTracking);
      } else {
        document.body.removeEventListener('ceros-analytics-event', cerosTracking);
      }
    }
    // Remove sticky position on byline ad after 2 Seconds
    if (BYLINE_STICKY_ON) {
      const sentinel = document.getElementById('sentinel');
      const stickyAd = document.getElementById('sticky-byline-wrapper');
      const observer = new IntersectionObserver(
        ([e]) => {
          if (e.boundingClientRect.top < 0) {
            setTimeout(() => { stickyAd.classList.add('unstick'); }, 2000);
          }
        }, { threshold: [1] },
      );
    }

    const e = document.getElementById('recipeSchema');
    const c = document.getElementById('chicoryScript');

    if (e && (this.props.article.category !== 'recipes')) {
      e.parentNode.removeChild(e);
    }
    if (c && (this.props.article.category !== 'recipes')) {
      c.parentNode.removeChild(c);
    }
  }

  togglePrint() {
    this.setState({ isPrintRecipe: true });
  }

  render() {
    const { average, numOfRatings, recirculation, articleUpdated } = this.state;
    const {
      article,
      brand,
      standardArticleTracker,
      isLoading,
      isMobile,
      isClient,
      onShowLeaderboard,
      showRightRail,
      shouldDestroyAds,
    } = this.props;

    const {
      category,
      subcategory,
      hedUrl,
      tags,
      settings,
      heroImage,
      social,
      isPublished,
      additionalAuthors,
      sponsorship,
      brandSafetyCat,
      brandSafetyRating,
      brandSafety,
    } = article;
  
    // these are duplicated in Lander.js. maybe move these to Redux store state.
    if (shouldDestroyAds) {
      // We may need to add in call to destoy ads with the FreeStar Component here
      // DFPManager.getGoogletag().then((gt) => { gt.destroySlots(); }).catch((error) => { sendLog('Article', "error", `DFPManager error ${error}`); });
    }
    if (isLoading) {
      return <Loading />;
    }
    const imagePreviewSize = ((isValid(heroImage.maxImageTag) && heroImage.maxImageTag === true) || (isValid(settings.maxImageTag) && settings.maxImageTag === true) || (isValid(social.maxImageTag) && social.maxImageTag === true)) ? 'large' : 'standard';

    let { modules = [] } = article;

    const customModule = modules.filter(module => module.type === 'custom-content');
    const hasCustom = (customModule && customModule.length > 0);
    if (hasCustom) {
      hasAds = false;
    }

    const recipeModule = modules.filter(module => module.type === 'recipe' || module.type === 'recipe-basic');
    const isRecipe = (recipeModule && recipeModule.length > 0);
    const recipeData = isRecipe ? recipeModule[0].data : null;
    const hideRecipeRatings = settings.hideRecipeRatings == 1;
    const hasRecipeImage = modules.filter(module => module.type === 'recipe').length > 0;

    const { isPrintRecipe } = this.state;

    const fullWidthImagemodule = modules.filter(module => module.type === 'full-width-image');
    const hasFullWidthImage = (fullWidthImagemodule && fullWidthImagemodule.length > 0);

    const isContentHub = settings.articleLayout === 'Content Hub';
    const isCeros = settings.articleLayout === 'Ceros';
    const isQuiz = settings.articleLayout === 'Quiz';
    const isGuide = settings.articleLayout === 'Guide';
    const isShoppableStorefront = settings.articleLayout === 'Shoppable Storefront';
    const articleType = (isValid(article.sponsorship)) ? article.sponsorship.articleType : null;
    const isSponsored = articleType === 'Sponsored';
    const isAffiliate = articleType === 'Affiliate';
    const isDedicated = articleType === 'Dedicated';

    let hasAds = !settings.disableAllAds && isClient;
    let hasLeaderboard = settings.showLeaderboard && isClient;
    let disableTrailerboard = false;
    const isTesting = APP_ENV === "PROD" ? "no" : "yes";
    if (typeof window !== 'undefined') {
      disableTrailerboard = (window.location.search.toLowerCase().includes('utm_source=jungroup') && window.location.search.toLowerCase().includes('utm_campaign=uniques'));
    }
    disableTrailerboard = (article.id === 669056 || article.id === 1133633) ? true : disableTrailerboard;

    let isVideoHero = false;
    let videoHero = [];
    let videoUrl = '';
    const videoModules = modules.filter(module => module.type === 'video-embed');
    if (videoModules.length > 0) {
      videoHero = videoModules.filter(module => module.data.videoEmbedLayout === 'wide');
      isVideoHero = (videoHero.length > 0) && !isContentHub;
      videoUrl = isValid(videoModules[0].data.embed) ? videoModules[0].data.embed.split('src="').pop().split('"')[0] : null;
    }
    const embedModule = modules.filter(module => module.type === 'social-embed');
    const hasSocialEmbed = (embedModule && embedModule.length > 0);

    const trackerHead = (isValid(article.settings.thirdPartyTrackerHead)) ? decodeTags(article.settings.thirdPartyTrackerHead) : null;
    let tracker = (isValid(article.settings.thirdPartyTrackerCode)) ? decodeTags(article.settings.thirdPartyTrackerCode) : null;
    const cacheBuster = Date.now().toString();
    const cacheArray = ['%%CACHEBUSTER%%', 'REPLACE-TIMESTAMP-MACRO', '[CACHEBUSTER]', '[timestamp]'];
    cacheArray.forEach((string) => {
      if (tracker && tracker.includes(string)) {
        tracker = tracker.replace(string, cacheBuster);
      }
    });

    const hasSlideshow = modules.some(m => m.type === 'slideshow');
    const hasQuiz = modules.some(m => m.type === 'quiz');
    const hasContentHeader = modules.some(m => m.type === 'content-header');

    const articleID = `article-${article.id}`;
    let className = !isCeros 
      ? `${brand} article article-${category}${isSponsored ? ' noskim noskimwords' : ''}${settings.articleLayout == 'Standard' ? ' standard' : ''}${hasRecipeImage ? ' recipe-hero' : ''}` 
      : 'article-ceros';
    // If last module is Related Tags (this module includes ads), no EOP ad
    const removeEOPAd = modules[modules.length - 1].type === 'related-tags' || (hasSlideshow && !isMobile) || (article.id === 1133633 && isMobile);
    // const adType = (category == 'fashion' || article.settings.hideProgrammaticAds == 1) ? 'directonly' : null;
    const adType = settings.hideProgrammaticAds == 1 ? 'directonly' : null;
    const adUnit = `${brand}/${category}/article`;

    // Ad Logic

    // only call onShowLeaderboard on first render
    if (isClient) {
      if (recirculation.length == 0 || isCeros || articleUpdated) {
        if (isMobile || hasSlideshow || hasCustom || !hasAds || (isSponsored && !hasLeaderboard)) {
          onShowLeaderboard(false, adUnit);
        } else {
          onShowLeaderboard(true, adUnit);
        }
      }
    }

     // set hasAds to false on first render
    hasAds = hasAds && (recirculation.length > 0 || isCeros);
    const hasRightRailAd = !isMobile && !hasSlideshow && !hasQuiz && !isContentHub && !isGuide && !isShoppableStorefront && !isCeros && hasAds && showRightRail;
    const showBylineAd = BYLINE_STICKY_ON && !(hasSlideshow || hasQuiz) && hasAds;

    if (hasAds && !isCeros) {
      if (isContentHub) {
        modules = getContentHubWithAds(modules, adUnit, isMobile);
      } else if (isGuide) {
        modules = getGuideWithAds(modules, adUnit, isMobile, isSponsored);
      } else if (hasQuiz) {
        modules = getQuizWithAds(modules, adUnit);
      } else if (isSponsored) {
        modules = getSponsoredArticleWithAds(modules, adUnit, isMobile);
      } else {
        modules = getArticleModulesWithAds(modules, adUnit, isMobile);
      }
    }

    // Build content hub subnav from nav-heads
    const navHeads = modules.filter(module => module.type === 'nav-head');
    const renderedContentNav = (navHeads && navHeads.length > 0) ? <ArticleContentNav navs={navHeads} isMobile={isMobile} hasContentHeader={hasContentHeader} /> : null;

    if (isContentHub) {
      className += ' content-hub';
      if (renderedContentNav) {
        className += ' with-content-nav';
      }
    }

    const getPubDate = () => {
      let pDate = null;
      if (isValid(article.publishData.date)) {
        pDate = new Date(article.publishData.date).toLocaleString('en-us', {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        });
      }
      return pDate;
    };
    const pubDate = getPubDate();

    const articlePath = `/${category}/${hedUrl}`;
    const articleUrl = `${SITE_HOST}${articlePath}`;
    const categoryUrl = `${SITE_HOST}/${category}`; 

    const disclaimerModule = modules.filter(module => module.type === 'disclaimer');
    const hasDisclaimer = (isValid(disclaimerModule));
    const horoscopeTags = ['zodiac', 'horoscopes', 'horoscope', 'astrology'];
    const isHoroscope = article.tags.some(tag => horoscopeTags.includes(tag));

    //Author
    let secondaryAuthor, secondAuthorName, secondAuthorText, secondAuthorUrl = null;
    if (isValid(additionalAuthors)) {
      secondaryAuthor= isValid(additionalAuthors.secondaryAuthor) && isValid(additionalAuthors.secondaryAuthor.authors) ? additionalAuthors.secondaryAuthor.authors[0] : null;
      secondAuthorName = isValid(additionalAuthors.secondaryAuthor) && isValid(additionalAuthors.secondaryAuthor.authors) ? additionalAuthors.secondaryAuthor.authors[0].name : null;
      secondAuthorText = isValid(additionalAuthors.secondaryAuthor) ? additionalAuthors.secondaryAuthor.text : null;
      secondAuthorUrl = isValid(additionalAuthors.secondaryAuthor) && isValid(additionalAuthors.secondaryAuthor.authors) ? additionalAuthors.secondaryAuthor.authors[0].link : null;
    }

    // Schema
    const articleSchemaType = (article.category === 'news' || article.category === 'entertainment' || isAffiliate || isHoroscope) ? 'NewsArticle' : 'Article';
    const datePublished = (isValid(article.publishData.first)) ? article.publishData.first.replace(/\s/g, 'T') : (isValid(article.publishData.date)) ? article.publishData.date.replace(/\s/g, 'T') : null;
    const dateModified = (isValid(article.publishData.date)) ? article.publishData.date.replace(/\s/g, 'T') : null;
    const keywords = (isValid(article.tags)) ? article.tags.join(', ') : null;
    const sameAs = [];
    const socialMap = ['twitter', 'insta', 'tikTok', 'personalSite', 'linkedin'];
    Object.keys(article.author).forEach(function(key) {
      if (socialMap.includes(key) && isValid(article.author[key])) {
        sameAs.push(article.author[key]);
      }
    });

    const description = article.author.description || null;
    let authorObject;
    if (description && isValid(sameAs)) {
      authorObject = {
          '@type': 'Person',
          'name': article.author.name,
          'description': description,
          'sameAs': sameAs, 
        }
    } else if (description) {
      authorObject = {
        '@type': 'Person',
        'name': article.author.name,
        'description': description,
      }
    } else if (isValid(sameAs)) {
      authorObject = {
        '@type': 'Person',
        'name': article.author.name,
        'sameAs': sameAs, 
      }
    } else {
      authorObject = {
        '@type': 'Person',
        'name': article.author.name,
      }
    }
    const schemaDataArray = [{
      '@context': 'https://schema.org/',
      '@type': articleSchemaType,
      'name': article.headline,
      'headline': article.headline,
      'keywords': keywords,
      'author': authorObject,
      'publisher': {
        '@type': 'Organization',
        'name': 'PureWow',
        'logo': 'https://www.purewow.com/static-gmg/purewow/logos/purewow-logo-black.webp',
        'url': 'https://www.purewow.com/',
        'sameAs': ['https://www.facebook.com/PureWow/',
                   'https://www.pinterest.com/purewow/',
                   'https://www.instagram.com/purewow/',
                   'https://www.tiktok.com/@purewow',
                   'https://www.youtube.com/user/PureWowVideos',
                    'https://twitter.com/purewow']
      },
      'articleSection': article.category,
      'image': {
        '@type': 'ImageObject',
        'url': article.social.facebookImage,
      },
      'datePublished': datePublished,
      'dateModified': dateModified,
      'description': article.seo.metaDescription,
      'mainEntityOfPage': {
        '@type': 'WebPage',
        '@id': articleUrl,
        'breadcrumb' : {
          '@type': 'BreadcrumbList',
            'itemListElement': [{
              '@type': 'ListItem',
              'position': 1,
              'name': article.category,
              'item': categoryUrl,
            },{
              '@type': 'ListItem',
              'position': 2,
              'name': article.headline,
          }],
        }
      }
    }];

    if (isValid(additionalAuthors) && isValid(additionalAuthors.tertiaryAuthor) && isValid(additionalAuthors.tertiaryAuthor.authors)) {
      let additionalAuthorArray = []
      additionalAuthors.tertiaryAuthor.authors.map((author) => {
        const additionalObject = {
        '@type': 'Person',
        'name': author.name,
        'url': SITE_HOST + '/author/' + author.link,
        }
        additionalAuthorArray.push(additionalObject);
      })
      schemaDataArray[0].mainEntityOfPage.reviewedBy = additionalAuthorArray;
      schemaDataArray[0].mainEntityOfPage.lastReviewed= datePublished;
    }

    const taggedShoppableArr = modules.filter(module => module.type === 'tagged-shoppable');
    if ((isValid(article.tagged_shoppable)) && (taggedShoppableArr.length === 0) && (!isCeros) && (article.settings.taggedShoppableGridPlacement === 'Default' || article.settings.taggedShoppableGridPlacement === 0)) {
      const taggedShoppableModule = {
        type: 'tagged-shoppable',
        data: article.tagged_shoppable,
      };
      modules.push(taggedShoppableModule);
    }
    const hasTaggedShoppable = (taggedShoppableArr.length !== 0);


    const shoppableGridModule = modules.filter(module => module.type === 'shoppable-grid');

    const hasShoppableGrid = ((isValid(shoppableGridModule)) && (shoppableGridModule.length !== 0));

    const mapShoppableProducts = (arr) => {
      if (!isValid(arr)) return [];
      const arr2 = [];
      arr.map((item) => {
        if (isValid(item) && isValid(item.data) && isValid(item.data.products)) {
          item.data.products.map((product) => {
            arr2.push(product);
          });
        }
      });
      return arr2;
    };

    const taggedShoppableProducts = mapShoppableProducts(taggedShoppableArr);
    const shoppableGridProducts = mapShoppableProducts(shoppableGridModule);

    const taggedShoppableSchema = [];
    if (hasTaggedShoppable) {
      taggedShoppableProducts.map((product) => {
        let itemPrice = (isValid(product.price) && isText(product.price)) ? product.price : null;
        const isNum = /^\d+$/.test(itemPrice);
        itemPrice = isNum ? itemPrice : null;
        const oldPrice = (isValid(product.oldPrice) && isText(product.oldPrice)) ? product.oldPrice : null;
        const description = isValid(product.productDescription) ? product.productDescription : null;
        let productName = (isValid(product.name) && isText(product.name)) ? product.name : null;
        productName = isValid(productName) ? decodeSpecialCharacters(productName) : null;
        const productItem = (isValid(productName) && isValid(itemPrice)) ? {} : null;
  
        if (isValid(productItem)) {
          productItem['@context'] = 'https://schema.org';
          productItem['@type'] = 'Product';
          productItem.image = product.productImage;
          productItem.name = productName;
          if (description !== null) {
            productItem.description = description;
          }
          if (isValid(itemPrice)) {
            productItem.offers = [{
              '@type': 'Offer',
              'price': itemPrice,
              'priceCurrency': 'USD',
              'url': product.buttonUrl,
            }];
          }
          if (isValid(oldPrice)) {
            (productItem.offers).push({
              '@type': 'Offer',
              'price': oldPrice,
              'priceCurrency': 'USD',
              'url': product.buttonUrl,
            });
          }
          taggedShoppableSchema.push(productItem);
        }
      });
    }

    const shoppableGridSchema = [];
    if (hasShoppableGrid) {
      shoppableGridProducts.map((product) => {
        let itemPrice = (isValid(product.price) && isText(product.price)) ? product.price : null;
        const isNum = /^\d+$/.test(itemPrice);
        itemPrice = isNum ? itemPrice : null;
        const oldPrice = (isValid(product.oldPrice) && isText(product.oldPrice)) ? product.oldPrice : null;
        const description = isValid(product.productDescription) ? product.productDescription : null;
        let productName = (isValid(product.name) && isText(product.name)) ? product.name : null;
        productName = isValid(productName) ? decodeSpecialCharacters(productName) : null;
        const productItem = (isValid(productName) && isValid(itemPrice)) ? {} : null;
  
        if (isValid(productItem)) {
          productItem['@context'] = 'https://schema.org';
          productItem['@type'] = 'Product';
          productItem.image = product.productImage;
          productItem.name = productName;
          if (isValid(description)) {
            productItem.description = description;
          }
          if (isValid(itemPrice)) {
            productItem.offers = [{
              '@type': 'Offer',
              'price': itemPrice,
              'priceCurrency': 'USD',
              'url': product.buttonUrl,
            }];
          }
          if (isValid(oldPrice)) {
            (productItem.offers).push({
              '@type': 'Offer',
              'price': oldPrice,
              'priceCurrency': 'USD',
              'url': product.buttonUrl,
            });
          }
          shoppableGridSchema.push(productItem);
        }
      });
    }

    const amazonProductModule = modules.filter(module => module.type === 'amazon-product-module');
    const isAmazonProduct = ((isValid(amazonProductModule)) && (amazonProductModule.length > 0));

    let amazonProductSchema = [];
    if (isAmazonProduct) {
      amazonProductModule.map((module) => {
        const { data } = module;
        const imageSrc = isMobile ? data.productImageMobile : data.productImageDesktop;
        let itemPrice = (isValid(data.price) && isText(data.price)) ? data.price : null;
        itemPrice = isValid(itemPrice) ? itemPrice.replace('$', '') : null;
        const isNum = /^\d+$/.test(itemPrice);
        itemPrice = isNum ? itemPrice : null;
        let itemOldPrice = (isValid(data.oldPrice) && isText(data.oldPrice)) ? data.oldPrice : null;
        itemOldPrice = isValid(itemOldPrice) ? itemOldPrice.replace('$', '') : null;
        let amazonProductName = (isValid(data.productName)) ? data.productName : null;
        amazonProductName = isValid(amazonProductName) && decodeTags(amazonProductName);
        amazonProductName = isValid(amazonProductName) && removeTags(amazonProductName);
        amazonProductName = isText(amazonProductName) ? amazonProductName.replace(/^[0-9]\. |^[0-9][0-9]\. /, '') : null;
        let description = isValid(data.bodyText) ? data.bodyText : null;
        description = decodeTags(description);
        description = removeTags(description);
        description = isValid(description) ? description.replace(/\n/g, ' ')
          .replace(/\s+/g, ' ')
          .replace(/&nbsp;/g, ' ') : description;
        const item = (isValid(amazonProductName) && isValid(itemPrice)) ? {} : null;
        
        if (isValid(item)) {
          item['@context'] = 'https://schema.org';
          item['@type'] = 'Product';
          item.image = imageSrc;
          item.brand = data.brand;
          item.name = amazonProductName;
          item.description = description;
          if (isValid(itemPrice)) {
            item.offers = [{
              '@type': 'Offer',
              'price': itemPrice,
              'priceCurrency': 'USD',
              'url': data.imgUrl,
            }];
          }
          if (isValid(itemOldPrice)) {
            (item.offers).push({
              '@type': 'Offer',
              'price': itemOldPrice,
              'priceCurrency': 'USD',
              'url': data.imgUrl,
            });
          }
          amazonProductSchema.push(item);
        }
      });
    }

    const largeProductModule = modules.filter(module => module.type === 'large-product');
    const isLargeProduct = ((isValid(largeProductModule)) && (largeProductModule.length > 0));
    
    let largeProductSchema = [];
    if (isLargeProduct) {
      largeProductModule.map((module) => {
        const { data } = module;

        const imageSrc = isMobile ? data.imageSrcMobile : data.imageSrcDesktop;
        let itemPrice = (isValid(data.price) && isText(data.price)) ? data.price : null;
        itemPrice = isValid(itemPrice) ? itemPrice.replace('$', '') : null;
        const isNum = /^\d+$/.test(itemPrice);
        itemPrice = isNum ? itemPrice : null;
        let itemOldPrice = (isValid(data.oldPrice) && isText(data.oldPrice)) ? data.oldPrice : null;
        itemOldPrice = isValid(itemOldPrice) ? itemOldPrice.replace('$', '') : null;
        let productName = (isValid(data.name)) ? data.name : null;
        productName = isValid(productName) && decodeTags(productName);
        productName = isValid(productName) && removeTags(productName);
        productName = isText(productName) ? productName.replace(/^[0-9]\. |^[0-9][0-9]\. /, '') : null;
        let description = isValid(data.bodyText) ? data.bodyText : null;
        description = decodeTags(description);
        description = removeTags(description);
        description = isValid(description) ? description.replace(/\n/g, ' ')
          .replace(/\s+/g, ' ')
          .replace(/&nbsp;/g, ' ') : description;

        const showProsCons = isValid(data.showProsCons);
        const hasProsCons = isValid(data.prosCons);
        const prosBulletData = (hasProsCons && isValid(data.prosCons.pros.data)) ? data.prosCons.pros.data : null;
        const consBulletData = (hasProsCons && isValid(data.prosCons.cons.data)) ? data.prosCons.cons.data : null;
        const prosBulletArr = isValid(prosBulletData) ? Object.values(prosBulletData) : null;
        const consBulletArr = isValid(consBulletData) ? Object.values(consBulletData) : null;

        const createItemListElementArray = (arr) => {
          if (!isValid(arr)) {
            return null;
          }
          return arr.map((listItem, position = 0) => {
            const objListItem = {
              '@type': 'ListItem',
              'position': position + 1,
              'name': listItem,
            };
            return objListItem;
          });
        };
          
        const item = (isValid(productName) && isValid(itemPrice)) ? {} : null;

        if (isValid(item)) {
          item['@context'] = 'https://schema.org';
          item['@type'] = 'Product';
          item.image = imageSrc;
          item.brand = data.brand;
          item.name = productName;
          item.description = description;
          if (showProsCons && (prosBulletData && consBulletData)) {
            item.review = {
              '@type': 'Review',
              'name': article.headline,
              'author': {
                '@type': 'Person',
                'name': article.author.name,
              },
              'positiveNotes': {
                '@type': 'ItemList',
                'itemListElement': isValid(prosBulletArr) ? createItemListElementArray(prosBulletArr) : null,
              },
              'negativeNotes': {
                '@type': 'ItemList',
                'itemListElement': isValid(consBulletArr) ? createItemListElementArray(consBulletArr) : null,
              },
            };
          }
          if (isValid(itemPrice)) {
            item.offers = [{
              '@type': 'Offer',
              'price': itemPrice,
              'priceCurrency': 'USD',
              'url': data.imageUrl,
            }];
          }
          if (isValid(itemOldPrice)) {
            (item.offers).push({
              '@type': 'Offer',
              'price': itemOldPrice,
              'priceCurrency': 'USD',
              'url': data.imageUrl,
            });
          }
          largeProductSchema.push(item);
        }
      });
    }

    const productsForLargeProductSchema = (isLargeProduct && isValid(largeProductSchema)) ? largeProductSchema : null;
    const productsForAmazonProductSchema = (isAmazonProduct && isValid(amazonProductSchema)) ? amazonProductSchema : null;
    const productsForShoppableGridSchema = hasShoppableGrid ? shoppableGridSchema : null;
    const productsForTaggedShoppableSchema = hasTaggedShoppable ? taggedShoppableSchema : null;
   
    let schemaData = null;
    if (isValid(schemaDataArray)) {
      schemaData = JSON.stringify(
        schemaDataArray,
      );
    }

    let amazonProductSchemaData = null;
    if (isValid(productsForAmazonProductSchema)) {
      amazonProductSchemaData = JSON.stringify(
        productsForAmazonProductSchema,
      );
    }

    let largeProductSchemaData = null;
    if (isValid(productsForLargeProductSchema)) {
      largeProductSchemaData = JSON.stringify(
        productsForLargeProductSchema,
      );
    }

    let shoppableGridSchemaData = null;
    if (isValid(productsForShoppableGridSchema)) {
      shoppableGridSchemaData = JSON.stringify(
        productsForShoppableGridSchema,
      );
    }

    let taggedShoppableSchemaData = null;
    if (isValid(productsForTaggedShoppableSchema)) {
      taggedShoppableSchemaData = JSON.stringify(
        productsForTaggedShoppableSchema,
      );
    }

    let heroImageUrl = articleUrl;

    if (isValid(heroImage.heroImageUrl)) {
      heroImageUrl = heroImage.heroImageUrl;
      if (!heroImageUrl.startsWith('https://' || 'http://')) {
        heroImageUrl = `https://${heroImageUrl}`;
      }
    }
    
    const HeroImage = withArticleTracking(ImageModule);
    const renderedHeroImage = (
      <HeroImage
        data={article.heroImage}
        isMobile={isMobile}
        isGuide={isGuide}
        isShoppableStorefront={isShoppableStorefront}
        fullUrl={heroImageUrl}
        heroImageUrl={heroImageUrl}
        wrapperClassName="module"
        className="hero-image"
        moduleName="large-image"
        seo={article.seo}  />
    ); 

    // Override default values for meta tags if provided
    const metaDefaultImage = article.heroImage.imageSrc;
    let metaFacebookImage;
    let metaTwitterImage;
    let metaArticleTitle;
    let metaSocialTitle;
    let metaArticleDescription;
    let metaArticleKeywords;
    let metaFacebookDescription;
    let metaFacebookTout;
    let metaTwitterDescription;
    let authorTwitter;
    let authorInstagram;
    let authorImg;
    let authorImgAlt;
    let authorLink;
    let categoryText;
    let advertiser;
    if (!isValid(article.social) || !isValid(article.seo)) {
      metaFacebookImage = metaDefaultImage;
      metaTwitterImage = metaDefaultImage;
      metaArticleTitle = article.headline;
      metaSocialTitle = article.headline;
      metaArticleDescription = '';
      metaArticleKeywords = '';
      metaFacebookDescription = metaArticleDescription;
      metaFacebookTout = '';
      metaTwitterDescription = metaArticleDescription;
      authorTwitter = 'https://twitter.com/purewow';
      authorInstagram = 'https://www.instagram.com/purewow/';
      authorImg = AUTHOR_IMAGE_PLACEHOLDER;
      authorImgAlt = getFileName(authorImg);
      authorLink = '';
      advertiser = article.settings.advertiserCode;
    } else {
      metaFacebookImage = article.social.facebookImage || metaDefaultImage;
      metaTwitterImage = article.social.twitterImage || metaDefaultImage;
      metaArticleTitle = article.social.facebookShareCopy ? article.social.facebookShareCopy : article.headline;
      metaSocialTitle = article.social.facebookShareCopy ? article.social.facebookShareCopy : article.headline;
      metaArticleDescription = article.seo.metaDescription || '';
      metaArticleKeywords = article.seo.metaKeywordOverride;
      metaFacebookDescription = metaArticleDescription || '';
      metaFacebookTout = article.social.facebookTout || '';
      metaTwitterDescription = article.social.twitterShareCopy || metaArticleDescription;
      authorTwitter = article.author.twitter || 'https://twitter.com/purewow';
      authorInstagram = article.author.insta || 'https://www.instagram.com/purewow/';
      authorImg = article.author.image || AUTHOR_IMAGE_PLACEHOLDER;
      authorImgAlt = article.author.imageAlt || getFileName(authorImg);
      authorLink = `/author/${article.author.link}`;
      categoryText = category;
      advertiser = article.settings.advertiserCode;
    }


    let includeAffilimate = isAffiliate && isPublished;
    if (typeof window !== 'undefined') {
      includeAffilimate = window.location.search.includes('allowDraft=true') ? false : includeAffilimate;
    }

    const dfpComment = `<!-- DFPP Hierarchy/Targeting:
      Page Type: article
      Ad Unit: ${adUnit}
      id: ${article.id}
      env: ${APP_ENV} 
      type: ${articleType}  -->`;

    let showHero = article.byline_display.heroImage == 1;
    if (hasCustom || isVideoHero || hasSlideshow) {
      showHero = false;
    }

    const heroImageSrc = isMobile ? article.heroImage.imageSrcMobile : article.heroImage.imageSrcDesktop;
    if ((settings.articleLayout === 'Quiz' || settings.articleLayout === 'Guide') && heroImageSrc !== null) {
      showHero = true;
    }

    const renderedContent = (() => (
      <div>
        {isQuiz && <QuizBox isQuiz={isQuiz} />}

        {((isGuide || isShoppableStorefront) && showHero) && renderedHeroImage}

        {((isGuide && isMobile) || (isShoppableStorefront && isMobile && showHero)) ? (
          <GuideArticleMobile
            data={article.guideTopComponent}
            article={article}
            isMobile={isMobile}
            isGuide={isGuide}
            articleLLayout={settings.articleLayout}
            isAffiliate={isAffiliate}
          />
        ) : (
          <Fragment>
            {(!hasCustom && !isCeros && (!hasContentHeader || isSponsored) && (!hasSlideshow || isMobile))
              && <Fragment>
                <ArticleHeader
                  category={category}
                  subcategory={subcategory}
                  categoryText={categoryText}
                  tags={article.tags}
                  display={article.byline_display}
                  article={article}
                  isGuide={isGuide}
                  isSponsored={isSponsored}
                  isShoppableStorefront={isShoppableStorefront}
                  isContentHub={isContentHub}
                  isMobile={isMobile}
                  authorTwitter={authorTwitter}
                  authorInstagram={authorInstagram}
                  sponsorship={sponsorship}
                  hasContentHeader={hasContentHeader}
                />
              </Fragment>
            }
            {(!isCeros && !hasCustom && (!hasSlideshow || isMobile)) && (
              <Byline
                imgURL={authorImg}
                imgAlt={authorImgAlt}
                name={article.author.name}
                link={authorLink}
                nameTwitter={authorTwitter}
                nameInstagram={authorInstagram}
                pubData={article.publishData}
                sponsorship={article.sponsorship}
                tags={article.tags}
                taggedSlugs={article.byline_display.taggedSlugs}
                showEditorByline={article.author.shouldShow}
                articleType={articleType}
                additionalAuthors={additionalAuthors}
                display={article.byline_display}
                isMobile={isMobile}
                isRecipe={isRecipe}
                isSponsored={isSponsored}
                togglePrint={this.togglePrint}
                hasContentHeader={hasContentHeader}
              />
            )}
            { showBylineAd
              && <Fragment>
                <div id="sentinel"/>
                <div id="sticky-byline-wrapper">
                  <div className='htlad-purewow_sticky_byline'
                    data-unit={adUnit}
                    data-targeting='{"slot_name":"purewow_sticky_byline"}'></div>
                </div>
              </Fragment>
            }
            { (!hasCustom && isVideoHero)
              && <Fragment>
                { recipeData && <RecipeHeader data={recipeData} slug={hedUrl} id={article.id} isMobile={isMobile} average={average} numOfRatings={numOfRatings} hideRecipeRatings={hideRecipeRatings}/> }
                <VideoHero categoryText={categoryText} article={article} moduleData={videoHero[0].data} />
              </Fragment>
            }
          </Fragment>
        )}

        {/* If article type is Affiliate, display the Product Review Process copy here */}
        { ((isAffiliate || hasTaggedShoppable) && (!hasSlideshow || isMobile) && !isCeros)
          && <ProductReviewProcess
            articleType={articleType}
            isMobile={isMobile}
            isAffiliate={isAffiliate}
            disclaimer={settings.disclaimer}
          />
        }
        { (recipeData && !isVideoHero)
          && <RecipeHeader data={recipeData} slug={hedUrl} id={article.id} isMobile={isMobile} average={average} numOfRatings={numOfRatings} hideRecipeRatings={hideRecipeRatings}/>
        }

        {(showHero && !hasContentHeader && !isGuide && !isShoppableStorefront)
          && renderedHeroImage
        }

        { !hasSlideshow && !isCeros && !hasFullWidthImage
          && <SocialShareButtons parent="sidebar" isMobile={isMobile} article={article} standardArticleTracker={standardArticleTracker} />
        }

        { hasRightRailAd
          && <div id="right-rail-container">
            <div className='htlad-purewow_rightrail'
                data-unit={adUnit}
                data-targeting='{"slot_name":"purewow_rightrail"}'></div>
          </div>
        }
        {isGuide || isShoppableStorefront ? (
          <ArticleModules
          id={article.id}
          headline={article.headline}
          guideBodyTextModule={article.guideTopComponent.guideBodyTextModule}
          isMobile={isMobile}
          modules={modules}
          fullUrl={articleUrl}
          slug={hedUrl}
          isClient={isClient}
          hasAds={hasAds}
          category={category}
          pubData={article.publishData}
          name={article.author.name}
          authorImg={authorImg}
          link={authorLink}
          sponsorship={article.sponsorship}
          tags={article.tags}
          display={article.byline_display}
          secondAuthorName={secondAuthorName}
          secondAuthorText={secondAuthorText}
          secondAuthorUrl={secondAuthorUrl}
          articleLayout={article.settings.articleLayout}
          navHeads={navHeads}
          seo={article.seo}
          settings={article.settings}
          adType={adType}
          isAffiliate={isAffiliate}
          productSummary={article.product_summary}
          showHero={showHero}
        />
        ) : (
          <ArticleModules
            id={article.id}
            headline={article.headline}
            isMobile={isMobile}
            modules={modules}
            fullUrl={articleUrl}
            slug={hedUrl}
            isClient={isClient}
            hasAds={hasAds}
            category={category}
            pubData={article.publishData}
            name={article.author.name}
            authorImg={authorImg}
            link={authorLink}
            sponsorship={article.sponsorship}
            tags={article.tags}
            display={article.byline_display}
            secondAuthorName={secondAuthorName}
            secondAuthorText={secondAuthorText}
            secondAuthorUrl={secondAuthorUrl}
            articleLayout={article.settings.articleLayout}
            navHeads={navHeads}
            seo={article.seo}
            settings={article.settings}
            adType={adType}
            isAffiliate={isAffiliate}
            productSummary={article.product_summary}
          />
        )}
        {(article.byline_display.hideBottomBio === 0 && !isCeros) &&
          <AuthorBios
            article={article}
            author={article.author}
            secondaryAuthor={secondaryAuthor}
            isMobile={isMobile}
          />
        }
        {hasDisclaimer &&
        <Disclaimer
          data={disclaimerModule[0].data}
          className="disclaimer"
          isAffiliate={isAffiliate}
        />
        }
      </div>
    ));
    const isVersioned = isValid(hedUrl) && hedUrl.includes("-versioned");
    const articleNoIndex = isTruthyMetaValue(article.seo.noIndex);
    const noIndex =
      (isPublished === false) ||
      (APP_ENV !== 'PROD') ||
      isVersioned ||
      articleNoIndex;
    const TrackedRenderedContent = withSegmentScroll(renderedContent);
    if (isRecipe && isPrintRecipe) {
      return (<PrintRecipe recipeData={recipeData} title={hedUrl} isMobile={isMobile} pubDate={pubDate} />);
    }

    const spotID = APP_ENV === "PROD" ? SPOT_ID_PROD : SPOT_ID_QA;
    const openWebArray = ["fashion", "beauty", "family", "wellness", "food", "travel", "recipes", "tech", "weddings", "home", "books", "money", "entertainment"];
    const includeOpenWeb = openWebArray.includes(category) && !isSponsored && settings.blockComments !== "1";
    const ua = isClient && typeof navigator !== "undefined" ? navigator.userAgent : "";
    const bot = isbot(ua) ? 'bot' : 'human';

    return (
        <Fragment>
          <Helmet>
              { includeAffilimate && <script>window.affilimate = null;</script>}
              { includeAffilimate &&
                <script>{`
                  window.pwLoadWhenIdle(function() {
                    var affilimateScript = document.createElement('script');
                    affilimateScript.async = true;
                    affilimateScript.src = 'https://snippet.affilimatejs.com';
                    document.head.appendChild(affilimateScript);
                  });
                `}</script>
              }
              { isAffiliate &&
                <script>{`
                  window.pwLoadWhenIdle(function() {
                    var skimlinksScript = document.createElement('script');
                    skimlinksScript.type = 'text/javascript';
                    skimlinksScript.async = true;
                    skimlinksScript.src = 'https://s.skimresources.com/js/27667X859343.skimlinks.js';
                    document.head.appendChild(skimlinksScript);
                  });
                `}</script>
              }
              { includeOpenWeb &&
                <script>{`
                  window.pwLoadWhenIdle(function() {
                    var openWebScript = document.createElement('script');
                    openWebScript.async = true;
                    openWebScript.src = 'https://launcher.spot.im/spot/${spotID}';
                    openWebScript.setAttribute('data-post-id', ${JSON.stringify(hedUrl)});
                    document.head.appendChild(openWebScript);
                  });
                `}</script>
              }
          </Helmet>
          { !isRecipe && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schemaData }} />}
          { (!isRecipe && largeProductSchemaData !== null) && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: largeProductSchemaData }} />}
          { (!isRecipe && amazonProductSchemaData !== null) && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: amazonProductSchemaData }} />}
          { (!isRecipe && shoppableGridSchemaData !== null) && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: shoppableGridSchemaData }} />}
          { (!isRecipe && taggedShoppableSchemaData !== null) && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: taggedShoppableSchemaData }} />}
          <MetaTags
            title={article.seo.titleTag}
            description={metaArticleDescription}
            url={articleUrl}
            tags={tags}
            category={category}
            rssCategory={category}
            articleType={articleType}
            ogType="article"
            ogTitle={metaSocialTitle}
            ogImage={metaFacebookImage}
            ogImageWidth="600px"
            ogImageHeight="300px"
            ogDescription={metaFacebookDescription}
            facebookTout={metaFacebookTout}
            twitterImg={metaTwitterImage}
            twitterDescription={metaTwitterDescription}
            keywords={metaArticleKeywords}
            canonicalUrl={articleUrl}
            noIndex={noIndex}
            advertiser={advertiser}
            trackerHead={trackerHead}
            pubDate={datePublished}
            modifiedDate={dateModified}
            videoUrl={videoUrl}
            imagePreviewSize={imagePreviewSize}
            affilimate={true}
            isAffiliate={isAffiliate}
            isRecipe={isRecipe}/>
          <div id={articleID} className={className}>
            <Fragment>
              <div dangerouslySetInnerHTML={{ __html: dfpComment }} />
              <TrackedRenderedContent
                standardArticleTracker={standardArticleTracker}/>
            </Fragment>
          </div>
          {(!hasCustom && !isCeros) && (
            <Fragment>
              { (hasAds && !removeEOPAd)
                &&  <div className='htlad-purewow_article_endofpage endofpage-ad-wrapper'
                    data-unit={adUnit}
                    data-targeting='{"slot_name":"purewow_article_endofpage"}'></div>
              }
              {!isCeros &&
                <SocialShareButtons parent="eop" isMobile={isMobile} article={article} standardArticleTracker={standardArticleTracker} togglePrint={this.togglePrint} />
              }
              {includeOpenWeb &&
                <Fragment>
                  <div data-spotim-module="conversation" 
                     className="open-web-conversation"
                     data-post-url={articleUrl}
                     data-article-tags={tags}
                     data-post-id={hedUrl}>
                  </div>
                  <div data-openweb-ad data-row="1" data-column="1" className="openweb-ad"></div>
                </Fragment>
              }
              {(article.settings.hideMoreStoriesYoullLove !== '1' && !isCeros && (isValid(recirculation)))
                && <Fragment>
                  <div className="more-articles">
                    <h2>More Stories You'll Love</h2>
                  </div>
                  <div className="recirculation grid-container">
                    <Recirculation recirculation={recirculation} isMobile={isMobile} isReferral="true"/>
                  </div>
                </Fragment>
              }
            </Fragment>
          )}
          { (isMobile && hasAds && !disableTrailerboard)
            && <div className='htlad-purewow_mobile_sticky_trailerboard  trailerboard-ad-wrapper'
                data-unit={adUnit}
                data-targeting='{"slot_name":"purewow_mobile_sticky_trailerboard"}'></div>
          }
          { tracker && <div className="third-party-tracking" dangerouslySetInnerHTML={{ __html: tracker }} /> }
        </Fragment>
    );
  }
}

const mapState = (state) => {
  const {
    pageData,
    isMobile,
    standardArticleTracker,
    isClient,
    showRightRail,
  } = state;
  const {
    pageType,
    brand,
    isLoading,
    shouldDestroyAds,
  } = pageData;

  if (pageType !== 'article') {
    return {
      article: {},
      brand: '',
      standardArticleTracker,
      isLoading: true,
      isMobile,
      isClient,
      showRightRail,
      shouldDestroyAds,
    };
  }

  const article = (isValid(pageData.article[0])) ? pageData.article[0] : {};

  return {
    article,
    brand,
    standardArticleTracker,
    isLoading,
    isMobile,
    isClient,
    showRightRail,
    shouldDestroyAds,
  };
};

const mapDispatchToProps = dispatch => ({
  onShowLeaderboard: (shouldShowAd, adUnit) => {
    dispatch({
      type: 'SHOW_LEADERBOARD',
      shouldShowAd,
      adUnit,
    });
  },
});

export default connect(mapState, mapDispatchToProps)(Article);
